import ReceiptsPage from '@/components/receipts/ReceiptsPage';

const Receipts = () => {
  return <ReceiptsPage />;
};

export default Receipts;
